import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  createHttpLink,
} from '@apollo/client';
import { concat } from '@apollo/client/link/core';
import { v4 as uuidv4 } from 'uuid';

export const IS_TESTING_ENVIRONMENT =
  // if explicitly set to production, always return false
  new URLSearchParams(window.location.search).get('environment') !== 'production' &&
  // running the code locally
  (process.env.NODE_ENV === 'development' ||
    window.location.host.includes('localhost') ||
    // test pages
    !!window.location.hostname?.startsWith?.('oneaudi-feature-app') ||
    // query parameter
    new URLSearchParams(window.location.search).get('environment') === 'development' ||
    // checking new QA pages
    window.location.hostname.startsWith('pre-') ||
    window.location.hostname.startsWith('qa') ||
    // Checking old QA pages
    (window.location.hostname === 'www.audi.ca' &&
      window.location.pathname.includes('test_pages')) ||
    (window.location.hostname === 'www.audiusa.com' &&
      window.location.pathname.includes('test_pages')));

export const IS_LOCAL_ENVIRONMENT = window.location.host.includes('localhost');

export const HOST_URL = window.location.origin;

export const IS_T3_WEBSITE = new URLSearchParams(window.location?.search).has('isdealer');

export const IS_T1_PAGE =
  window.location.hostname === 'www.audi.ca' ||
  window.location.hostname === 'www.audiusa.com' ||
  new URLSearchParams(window.location?.search).has('tier1');

const urlPath = typeof window !== 'undefined' ? window.location.pathname : '';
const hashParams = typeof window !== 'undefined' ? window.location.hash : '';

const queryParams = typeof window !== 'undefined' ? window.location.search : '';

export const IS_VDP_PAGE =
  (urlPath.includes('vehicle') && queryParams.includes('vehicleId')) ||
  (urlPath.includes('vehicule') && queryParams.includes('vehicleId'));
export const IS_VLP_PAGE =
  (urlPath.includes('inventory') && !urlPath.includes('vehicle')) ||
  (urlPath.includes('inventaire') && !urlPath.includes('vehicule'));
export const IS_OFFERS_PAGE = urlPath.includes('promotions') || urlPath.includes('offers');
export const IS_BUILD_PAGE = urlPath.includes('build');
export const IS_MODELS_PAGE =
  urlPath.includes('models') && !urlPath.includes('find-your-match') && !urlPath.includes('build');
export const IS_FYM_PAGE = urlPath.includes('find-your-match');

export const IS_MLP_PAGE = new URLSearchParams(hashParams.substring(1)).get('carline');
export const IS_NGC_PAGE = new URLSearchParams(hashParams.substring(1)).get('audiCode');

export const GRAPHQL_GATEWAY_URL = IS_TESTING_ENVIRONMENT
  ? 'https://qa-api.audiusa.com/graphql'
  : 'https://api.audiusa.com/graphql';

export const DEALER_GATEWAY_URL = 'https://dealer-graphql.apps.emea.vwapps.io/';

export const ONEGRAPH_GATEWAY_URL = IS_TESTING_ENVIRONMENT
  ? 'https://int.onegraph.audi.com/graphql'
  : 'https://onegraph.audi.com/graphql';

export const ELSP_URL = IS_TESTING_ENVIRONMENT
  ? 'https://qa.vwdigitalenterpriseleadsubmission.svc.vwusa.io'
  : 'https://prod.vwdigitalenterpriseleadsubmission.svc.vwusa.io';

export const DEALER_BY_ID_URL = IS_TESTING_ENVIRONMENT
  ? 'https://qa-api.audiusa.com/graphql'
  : 'https://api.audiusa.com/graphql';

export const CIGS_URL = IS_TESTING_ENVIRONMENT
  ? 'https://qa.aoaaudicigs.svc.audiusa.io'
  : 'https://prod.aoaaudicigs.svc.audiusa.io';

export const REMOTE_HANDRAISER_CONFIG =
  'https://fa-digital-leads.cdn.prod.collab.apps.one.audi/hrConfig.json';

const correlationIdLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'x-correlation-id': uuidv4(),
    },
  }));

  return forward(operation);
});

const superGraphLink = createHttpLink({
  uri: GRAPHQL_GATEWAY_URL,
});

const dealerGraphLink = createHttpLink({
  uri: DEALER_GATEWAY_URL,
});

const dealerByIdLink = createHttpLink({
  uri: DEALER_BY_ID_URL,
});

const oneGraphLink = createHttpLink({
  uri: ONEGRAPH_GATEWAY_URL,
});

export const apolloClient = new ApolloClient({
  link: concat(correlationIdLink, superGraphLink),
  cache: new InMemoryCache(),
  name: __FEATURE_APP_NAME__,
  version: __FEATURE_APP_VERSION__,
});

export const dealerClient = new ApolloClient({
  link: concat(correlationIdLink, dealerGraphLink),
  cache: new InMemoryCache(),
  name: __FEATURE_APP_NAME__,
  version: __FEATURE_APP_VERSION__,
});

export const oneGraphClient = new ApolloClient({
  link: concat(correlationIdLink, oneGraphLink),
  cache: new InMemoryCache(),
  name: __FEATURE_APP_NAME__,
  version: __FEATURE_APP_VERSION__,
});

export const dealerByIdClient = new ApolloClient({
  link: concat(correlationIdLink, dealerByIdLink),
  cache: new InMemoryCache(),
  name: __FEATURE_APP_NAME__,
  version: __FEATURE_APP_VERSION__,
});
